import NoteManagePane from './NoteManagePane';

export default NoteManagePane;
export { NoteManagePane };
